import { type FC } from 'react'
import { RinglessMessageFieldContext } from 'widgets/MessageFormFields/RinglessMessageField/context/ringlessMessageFieldContext'
import type { RinglessMessageFieldStore } from 'widgets/MessageFormFields/RinglessMessageField/store/ringlessMessageFieldStore'
import {
  type IRinglessMessageFieldContent,
  RinglessMessageFieldContent,
} from 'widgets/MessageFormFields/RinglessMessageField/ui/RinglessMessageFieldContent'

type IRinglessMessageField = {
  store: RinglessMessageFieldStore
} & IRinglessMessageFieldContent

export const RinglessMessageField: FC<IRinglessMessageField> = ({ store, ...props }) => {
  return (
    <RinglessMessageFieldContext.Provider value={store}>
      <RinglessMessageFieldContent {...props} />
    </RinglessMessageFieldContext.Provider>
  )
}
